/** Pure text helpers for the queue cell and the tables' time columns
 * (moved out of OrdersPage unchanged — SA-397). */

export function initialsFor(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return ''
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function timeAgo(dateStr: string | null | undefined, now: Date = new Date()) {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  const diffMs = now.getTime() - d.getTime()
  const diffMin = Math.floor(diffMs / 60000)
  if (diffMin < 60) return `${diffMin}m ago`
  const diffHr = Math.floor(diffMin / 60)
  if (diffHr < 24) return `${diffHr}h ago`
  const diffDay = Math.floor(diffHr / 24)
  return `${diffDay}d ago`
}

/** Waiting-duration phrasing (spec §5.2/§7): "waiting 3h on commercial", not
 * "...3h ago on..." — strips timeAgo()'s "ago" suffix for this one line. */
export function waitingDuration(dateStr: string | null) {
  return timeAgo(dateStr).replace(/ ago$/, '')
}
